export type RealtimePollGroup =
  | 'IMPORT'
  | 'STUDIES'
  | 'KNOWLEDGE'
  | 'REPORT'
  | 'WORKFLOW'
  | 'QUESTIONNAIRE'
  | 'PUBLIC'

/**
 * Per-group restore of the old HTTP interval without a deploy.
 * Keep for one release cycle after sockets-only; default off.
 */
export function isLegacyPollFallbackEnabled(group: RealtimePollGroup): boolean {
  const key = `DT_VITE_REALTIME_${group}_POLL_FALLBACK` as keyof ImportMetaEnv
  const raw = import.meta.env[key]
  return raw === '1' || raw === 'true'
}

export function legacyRefreshInterval(
  group: RealtimePollGroup,
  intervalMs: number,
): number {
  return isLegacyPollFallbackEnabled(group) ? intervalMs : 0
}
